import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !NO_RETRY.some((u) => cfg.url?.includes(u))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.response ? "Something went wrong. Please try again." : "We couldn't reach the server. Check your connection.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
  return typeof detail.msg === "string" ? detail.msg : "Something went wrong. Please try again.";
}
